
<div>
    <v-menu
        v-model="menu"
        style  = "z-index: 800; margin-left: 10px"
        :close-on-content-click="false"
        offset-y
    >
        <template v-slot:activator="{ on, attrs }" >
            <a
                v-bind = "attrs"
                v-on   = "on"
                class  = "step-icon"
            >
                <slot name="icon"></slot>
                <span class="mr-1">{{ documents.length }}</span>
                <i class="ml-0 pr-2 fas" :class="menu?'fa-caret-up ' + color:'fa-caret-down ' + color"></i>
            </a>
        </template>

        <div class="document-list">
            <p-dms-detail-menu-entry
                v-for="(document, index) in documents" :key="index"
                :document    = "document"
                :enable-drag = "enableDrag"
                :enable-menu = "enableMenu"
                :class       = "index > 0 ? 'mt-1' : ''"
                @selected    = "onSelected"
            />
        </div>
    </v-menu>
</div>
